import type * as z from 'zod'
import { sourceJson, wireValue } from './entity-edits'
import { attachRaw } from './raw'
import { objectSchema, parseEntity } from './schema'
import { attachUnknown, getUnknown, isDegraded } from './unknown'

const payloadSchema = objectSchema({})

/** Keep the constructor payload on a class that has no field schema yet. */
export function rememberPayload(entity: object, json: unknown): void {
  applyEntitySchema(entity, payloadSchema, wireValue(sourceJson(json ?? {})), {})
}

/**
 * Record `$raw` and `$unknown` for a class instance.
 * A top-level path listed in `fallbacks` replaces the view value. Nested paths stay on `$unknown`
 * so a bad child does not wipe its siblings.
 */
export function applyEntitySchema(
  entity: object,
  schema: z.ZodType,
  source: unknown,
  fallbacks: Readonly<Record<string, unknown>>
): void {
  const parsed = parseEntity(schema, source, entity.constructor?.name || 'entity') as object
  const unknown = getUnknown(parsed)
  const record = entity as Record<string, unknown>

  for (const path of unknown) {
    if (path.includes('.')) {
      continue
    }

    if (Object.prototype.hasOwnProperty.call(fallbacks, path)) {
      record[path] = fallbacks[path]
    }
  }

  attachRaw(entity, source)
  attachUnknown(entity, unknown, isDegraded(parsed))
}
